import React, { useEffect } from 'react';
import { LandingPage } from './pages/LandingPage';
import { loadMetaPixel } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    loadMetaPixel();
  }, []);
  return <LandingPage data-id="element-0" data-mp="3ka4az1vdgbjc" />;
}